/**
 * Infrastructure Module
 *
 * @version 1.0
 * @module core/modules/infrastructure
 *
 * @description
 * Módulo de Infraestructura Urbana: alumbrado, semáforos, mobiliario urbano.
 * Auto-registro en el moduleRegistry al importarse.
 */

import { moduleRegistry } from '../../module-registry';
import { InfrastructureTabbedPanel } from './InfrastructureTabbedPanel';

export { InfrastructureTabbedPanel };

/* ===== AUTO-REGISTRO DEL MÓDULO ===== */

moduleRegistry.register({
  id: 'infrastructure',
  leftPanel: InfrastructureTabbedPanel,
  enabledByDefault: false,
});
